/*
 const debug = process.env.NODE_ENV !== 'production'
 const API_ROOT = debug ? 'http://lvbqas.eastmoney.com:8003/operation/' : 'http://lvbqas.eastmoney.com:8003/operation/'
 export {
 API_ROOT
 }
 */
/**
 * 配置vconsole 调试域名
 * @type {string[]}
 */
const debugUrlArr = ['https://livemoneyapitest.eastmoney.com', 'http://lvbqas.eastmoney.com', 'https://lvbmoneyapi-qas.eastmoney.com']
export {
  debugUrlArr
}



// WEBPACK FOOTER //
// ./src/config.js